// extracted by mini-css-extract-plugin
export default {"bounce":"q_cC","loading":"q_cD","logo-mark-bounce-right":"q_cF","logo-mark-bounce-left":"q_cG"};